import React from 'react';
import { Text } from '@doda/io-react/common';
import { TextWithLF } from '@doda/common/src/components/TextWithLF';
import { SectionItem } from '../../SectionItem';

import { LightBlueSubTitle } from '../LightBlueSubTitle';
import { SubSection } from '../../SubSection';
import styles from '../index.module.scss';

/**
 * JobDescriptionのProps
 */
interface JobDescriptionProps {
  /** 仕事内容概要 */
  jobContentOutline: string;
  /** 具体的な仕事内容 */
  jobContentDetail: string;
  /* チーム・組織構成*/
  teamStructure: string;
  /** 組織名称 */
  organizationCategory: string;
  /** 男女比 */
  genderRatio: string;
  /** 年齢構成 */
  ageComposition: string;
  /** 定着率 */
  retentionRate: string;
  /** 職種別項目 */
  projectCase: string;
  /** 職種別項目タイトル */
  projectCaseTitle: string;
  /** 職種別項目2 */
  developmentEnvironment: string;
  /** 職種別項目タイトル2 */
  developmentEnvironmentTitle: string;
}

/**
 * 仕事内容概要と具体的な仕事内容を表示するコンポーネント
 *
 * @param {string} props.jobContentOutline - 仕事内容概要の区分
 * @param {string} props.jobContentDetail - 具体的な仕事内容
 */
export const JobDescription: React.FC<JobDescriptionProps> = ({
  jobContentOutline,
  jobContentDetail,
  teamStructure,
  organizationCategory,
  genderRatio,
  ageComposition,
  retentionRate,
  projectCase,
  projectCaseTitle,
  developmentEnvironment,
  developmentEnvironmentTitle,
}) => {
  return (
    <SectionItem label="仕事内容">
      <Text weight="bold" style={{ marginBottom: '16px' }}>
        <TextWithLF text={jobContentOutline} />
      </Text>
      <div className={styles['jobSearchDetail-body__lightBlueSubTitle']}>
        <LightBlueSubTitle label="具体的な仕事内容" />
      </div>
      <div className={styles['jobSearchDetail-body__lightBlueSubTitle-text']}>
        <TextWithLF text={jobContentDetail} />
      </div>

      {teamStructure && (
        <div className={styles['jobSearchDetail-body__lightBlueSubTitle']}>
          <LightBlueSubTitle label="チーム組織構成" />
          <div
            className={styles['jobSearchDetail-body__lightBlueSubTitle-text']}
          >
            <TextWithLF text={teamStructure} />
          </div>
        </div>
      )}

      {organizationCategory && (
        <div className={styles['jobSearchDetail-body__subSectionItem']}>
          <SubSection label="組織名称">{organizationCategory}</SubSection>
        </div>
      )}

      {genderRatio && (
        <div className={styles['jobSearchDetail-body__subSectionItem']}>
          <SubSection label="男女比">{genderRatio}</SubSection>
        </div>
      )}

      {ageComposition && (
        <div className={styles['jobSearchDetail-body__subSectionItem']}>
          <SubSection label="年齢構成">{ageComposition}</SubSection>
        </div>
      )}

      {retentionRate && (
        <div className={styles['jobSearchDetail-body__subSectionItem']}>
          <SubSection label="定着率">{retentionRate}</SubSection>
        </div>
      )}
      {projectCaseTitle && projectCase && (
        <div className={styles['jobSearchDetail-body__subSectionItem']}>
          <SubSection label={projectCaseTitle}>
            <TextWithLF text={projectCase} />
          </SubSection>
        </div>
      )}
      {developmentEnvironmentTitle && developmentEnvironment && (
        <div className={styles['jobSearchDetail-body__subSectionItem']}>
          <SubSection label={developmentEnvironmentTitle}>
            <TextWithLF text={developmentEnvironment} />
          </SubSection>
        </div>
      )}
    </SectionItem>
  );
};
